import React, { useState, useEffect } from 'react'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import * as Yup from 'yup'
import { Formik, Form, Field, FieldArray ,ErrorMessage} from 'formik';
import * as AiIcons from 'react-icons/ai';
import swal from '@sweetalert/with-react';
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import axios from 'axios'

function ImsNewFormsStage2() {
    const { orgcode } = useParams()
    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        address: "",
        teamleaderName:"",
        teamleader:"",
       
        siteofaddress: '',
        dateofaudit: "",
        clientcode: "",
        effectiveNoEmpToBeAudited: "",
        email: "",
        contactPersonName: "",
        position:"",
        telephone: "",
        nabcbcode: "",
        nabcbcodeName: "",
        scope: "",
        nonapprequirements: "Yes",
        typeofauditonAuditReport: "",
        significantchanges: "",
        auditteam: "",
        placeofaudit: "",
        briefaboutorg: "",
        anydeviationinauditplan: "",
        anysignificantissue: "",
        anyunresolved: "",
        verificationofeffectiveness: "",
        criteriaofaudit: "",
        objectiveofaudit: "",
        reasons: "",
        summary: "",
        auditorteamObservation:"",
        noncom:"",
        processAuditReportDetails: [{
            nameofprocessid:"",
            nameofprocess: "",
            processowner: "",
            details: "",
            reference: "",
            comments: "",
            clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
            clausesList: [{ label: "Select", value: "-" }]


        }],
        otherstageofaudit: "",
        otherrecommendationsOptions: "",
        proposedAuditDateforSurveillanceAudit: new Date(),
        signofDate:new Date()
    })
    const [otherOptions, setotherOption] = useState(false)
    const [recommendationsOptions, setrecommendationsOptions] = useState(false)
    const stageaudit = [
        { key: 'Select', value: '-' },
        { key: 'Initial Certification', value: 'Initial Certification' },
        { key: 'Post Audit', value: 'Post Audit' },
        { key: 'Surveillance Cum Transfer', value: 'Surveillance Cum Transfer' },
        { key: 'Modification', value: 'Modification' },
        { key: 'Renewal', value: 'Renewal' },
        { key: 'Upgrade from', value: 'Upgrade from' },
        { key: 'other', value: 'other' }
    ]
    const recommendation = [
        { key: 'Select', value: '-' },
        { key: 'Issuance of the certificate', value: 'Issuance of the certificate' },
        { key: 'Use of the IQCPL & NABCB Logo as per Guidance for Usage of Logo', value: 'Use of the IQCPL & NABCB Logo as per Guidance for Usage of Logo' },
        { key: 'Refusal of the certificate', value: 'Refusal of the certificate' },
        { key: 'Post audit', value: 'Post audit' },
        { key: 'Modification of the current certificate (registration n° and expiration date remain unchanged)', value: 'Modification of the current certificate (registration n° and expiration date remain unchanged)' },
        { key: 'other', value: 'other' },
    ]
    const options = [
        { key: 'Select', value: '-' },
        { key: 'Initial Audit', value: 'Initial Audit' },
        { key: 'Special Audit', value: 'Special Audit' }
    ]

    const requirements = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]

    const { data: processList, isLoading: processListLoading } = useQuery(
        'listprocess',
        () => Fetcher('get', '/api/clauses/get/listclauseswithkeylabel', {}))

    const onSubmit = (values, { setSubmitting, resetForm }) => {

        mutation.mutate(values)
    }
    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/imsallstage2auditreport', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'IMS Stage 2 Data Added')
                console.log("data 141",data.data.response)
                // history.push('/admin/view/auditreport/' + data.data.response.orgCode);
                //window.location.href = "/" + localStorage.getItem("role") + "/view/auditreport/" + data.data.response.orgCode

            } else {
                var msg = 'IMS Stage 2 - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesofimsallstage2data/' + localStorage.getItem("userCode"), {}))


    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {
            console.log("stage two data",data.data.response)
            
            if (data.data.errorCode === 0) {
                var tempInitialValues = {...data.data.response};
                console.log("temp initial values",tempInitialValues)
                tempInitialValues.clientcode = data.data.response.orgSerialNumber || "";
                tempInitialValues.telephone = data.data.response.telephone || "";
                tempInitialValues.contactPersonName = data.data.response.contactPersonName || "";
                tempInitialValues.position = data.data.response.position || "";
                tempInitialValues.typeofauditonAuditReport = data.data.response.typeofauditonAuditReport || "Stage 2";
                tempInitialValues.effectiveNoEmpToBeAudited = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.email = data.data.response.email || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.proposedAuditDateforSurveillanceAudit = Date.parse(data.data.response.proposedAuditDateforSurveillanceAudit) || null;
                tempInitialValues.signofDate = Date.parse(data.data.response.signofDate) || null;

                tempInitialValues.scope = data.data.response.scope || "";
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";

                tempInitialValues.nabcbcodeName = data.data.response.nabcbcodeName || "";
                tempInitialValues.summary = data.data.response.summary || "";
                tempInitialValues.auditorteamObservation = data.data.response.auditorteamObservation || "";
                tempInitialValues.noncom = data.data.response.noncom || "";
                tempInitialValues.stageofaudit = data.data.response.stageofaudit || "";
                tempInitialValues.recommendations = data.data.response.recommendations || "";
                tempInitialValues.reasons = data.data.response.reasons || "";
                tempInitialValues.nonapprequirements = data.data.response.nonapprequirements || "";
                tempInitialValues.mobile = data.data.response.mobile || "";
    
                tempInitialValues.processAuditReportDetails = data.data.response.processAuditReportDetails.length > 0 ? data.data.response.processAuditReportDetails : [{
                    nameofprocess: "",
                    nameofprocessid:"",
                    processowner: "",
                    details: "",
                    reference: "",
                    comments: "",
                    clausesList: [],
                    clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
                }]
                console.log("process details", data.data.response.processAuditReportDetails)
                console.log("processList ",processList.data.response)
                console.log("Process Len",data.data.response.processAuditReportDetails)
                if(data.data.response.processAuditReportDetails.length > 0)
                {
                    for(let j = 0 ; j < tempInitialValues.processAuditReportDetails.length ; j++){
                        console.log("processAuditReportDetails.nameodprocess ",tempInitialValues.processAuditReportDetails[j].nameofprocess)
                        var clauseListdata = processList.data.response.find(e=> e.label === tempInitialValues.processAuditReportDetails[j].nameofprocess)
                        console.log("clause List data",clauseListdata)
                        if(clauseListdata) {
                        tempInitialValues.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                    }
                }
                }
                console.log("tempIni",tempInitialValues)
                setInitialValues(tempInitialValues)
            } 
            // else  if(data.data.errorCode === 0){
            //     var msg = 'This Form Collects information for - ISO 27001-2013 ISMS Requirements' + data.data.errorMsg;
            //     // ToastInstance('Error', msg)
            //     window.location.href = "/" + localStorage.getItem("role") + "/view/auditreport/" + data.data.response.orgCode

            // }
            else{
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const { data: nacecodeList, isLoading: nacecodeListLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/nace/get/listnacecodewithkeylabel', {}))

    


    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(stage2data=>{
            if (stage2data && initialValues.orgCode === 0) {
                var tempData = stage2data.data.response
                console.log("temdata 242",tempData)
                tempData.dateofaudit = Date.parse(tempData.dateofaudit)
                tempData.proposedAuditDateforSurveillanceAudit = Date.parse(tempData.proposedAuditDateforSurveillanceAudit)
                tempData.signofDate = Date.parse(tempData.signofDate)
    
                tempData.typeofauditonAuditReport = tempData.typeofauditonAuditReport || "Stage 2";
                tempData.summary = tempData.summary || "";
                tempData.auditorteamObservation = tempData.auditorteamObservation || "";
                tempData.noncom = tempData.noncom || "";
                tempData.position = tempData.position || "";
                tempData.mobile =tempData.mobile || "";
                var temp2 = tempData.processAuditReportDetails.map((clno) => clno )
    
                tempData.processAuditReportDetails = tempData.processAuditReportDetails.length > 0 ? tempData.processAuditReportDetails : [{
                    nameofprocess: "",
                    nameofprocessid:"",
                    processowner: "",
                    details: "",
                    reference: "",
                    comments: "",
                    clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
                    clausesList: [],
    
    
                }]
                if(stage2data.data.response.processAuditReportDetails.length > 0)
                {
                    for(let j = 0 ; j < tempData.processAuditReportDetails.length ; j++){
                        console.log("processAuditReportDetails.nameodprocess ",tempData.processAuditReportDetails[j].nameofprocess)
                        var clauseListdata = processList.data.response.find(e=> e.label === tempData.processAuditReportDetails[j].nameofprocess)
                        console.log("clause List data",clauseListdata)
                        if(clauseListdata)
                        {
                        tempData.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                        }
                    }
                }
                
    
                if (tempData.stageofaudit === "other") {
    
                    setotherOption(true)
                    tempData.otherstageofaudit = stage2data.data.response.otherstageofaudit
                }
                else {
                    setotherOption(false)
    
                }
    
                if (tempData.recommendations === "other") {
    
                    setrecommendationsOptions(true)
                    tempData.otherrecommendationsOptions = stage2data.data.response.otherrecommendationsOptions
                }
                else {
                    setrecommendationsOptions(false)
                }
                setInitialValues(tempData)
    
            }

            
           
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }

        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    const validationSchema = Yup.object({

        typeofauditonAuditReport: Yup.string().required('Required'),
      
        placeofaudit: Yup.string().required('Required'),
        briefaboutorg: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        anydeviationinauditplan: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        anysignificantissue: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        anyunresolved: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        verificationofeffectiveness: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        criteriaofaudit: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        objectiveofaudit: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
       
     
        processAuditReportDetails: Yup.array().of( Yup.object().shape({
           
            nameofprocessid:  Yup.string().required("Name of Process Required"),
          
            processowner: Yup.string().required("Process Owner Required"),
            details: Yup.string().required("Details Required"),
           
            comments:Yup.string().required("Comments Required"),
           
            clauseWiseObservation: Yup.array().of( Yup.object().shape({
                clauseNo: Yup.string().required("Clause No.  Required"),
                 Observation: Yup.string().required("Observation  Required")
            }))
            
            })
          )

       

    })


    if (companyListLoading || nacecodeListLoading || processListLoading) return <h1>Loading</h1>
    
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                //validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <form>
                                                        <div className="formOuterDiv">
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' options={OrgList.data.response} label='Name of the Organization' name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} type="text" />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='address' label='Address' />
                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='siteofaddress' label='Site Address (If any)' />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='clientcode' label='Client Code' />
                                                                <FormikControl control='input' type="text" name='effectiveNoEmpToBeAudited' label='No. of Employees' />

                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='email' label='Email id' />
                                                                <FormikControl control='input' type="text" name='contactPersonName' label='Contact Person' />

                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='mobile' label='Contact No' />
                                                                <FormikControl control='input' type="text" label='ANZSIC Code / NACE CODE' name='nabcbcodeName' disabled={true} />

                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='scope' label='Scope' />

                                                            </div>
                                                            <div className="row mt-4" style={{ marginLeft: "0.2%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-4">Non Applicable Requirements</label>
                                                                <div className="col-sm-6">
                                                                    <FormikControl control='checkboxhorizantal' options={requirements} name='nonapprequirements' />
                                                                </div>
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='select' type="text" name='typeofauditonAuditReport' options={options} label='Type of Audit(S) *' />

                                                            </div>
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='significantchanges' label='Significant Changes(if any),Since last audit that affects QMS/EMS/OHSMS' />
                                                            </div>
                                                            
                                                            <div className="form2RowDiv">
                                                          
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy" name='dateofaudit' className="form-control" label='Date of Audit' />
                                                                <FormikControl control='input' type="text" name='placeofaudit' label='Place of the Audit *' />

                                                            </div>
                                                           
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='anydeviationinauditplan' label='Any Deviation in the Audit Plan and Reason(if any) *' />
                                                            </div>

                                                            <div className="fieldarray mt-3">

                                                                <FieldArray name='processAuditReportDetails'>

                                                                    {fieldArrayProps => {
                                                                        const { push, remove, form } = fieldArrayProps
                                                                        const { values } = form
                                                                        const { processAuditReportDetails } = values
                                                                        return (
                                                                            <div>
                                                                                {processAuditReportDetails.map((processDetail, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="form2RowDiv">
                                                                                            <div className="formSingleElement">
                                                                                                <FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].nameofprocessid`} label='Name of the Process' options={processList.data.response}
                                                                                                    onChange={(e) => {

                                                                                                        var fillteredprocess = processAuditReportDetails.find(x => x.nameofprocessid === e.value)

                                                                                                        if (fillteredprocess) {
                                                                                                            swal({
                                                                                                                title: "Process is Already selected",
                                                                                                                icon: "warning",
                                                                                                                dangerMode: true,
                                                                                                            })
                                                                                                        } else {
                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocess`, e.label)
                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocessid`, e.value)
 
                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].reference`, e.listClauses)

                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].clausesList`, e.clausesList)
                                                                                                           

                                                                                                        }

                                                                                                    }

                                                                                                    } />

                                                                                            </div>
                                                                                            <div className="formSingleElement">
                                                                                                <label className="formSingleElementLabel">Process Owner</label>
                                                                                                <Field className="form-control" name={`processAuditReportDetails[${index}].processowner`} />
                                                                                                <div style={{color:"red",fontSize:"15px"}}>
                                                                                            <ErrorMessage name={`processAuditReportDetails[${index}].processowner`} />
                                                                                            </div>
                                                                                            </div>
                                                                                        </div>


                                                                                        <div className="form1RowDiv ">
                                                                                            <div className="formSingleElement">
                                                                                                    <label className="formSingleElementLabel">References</label>
                                                                                                    <Field className="form-control" name={`processAuditReportDetails[${index}].reference`} />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mt-5" style={{ margin: "1%" }}>

                                                                                            <div className="col-sm-11">
                                                                                                <label htmlFor="staticEmail" className="col-sm-5 mt-1 mb-1">Details</label>
                                                                                                <FormikControl control='ckEditor' name={`processAuditReportDetails[${index}].details`} className="form-control" data={initialValues.processAuditReportDetails.details} />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row mt-3" style={{ margin: "1%" }}>
                                                                                            <label className="formSingleElementLabel">Auditor comments on</label>
                                                                                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].comments`} />
                                                                                            <div style={{color:"red"}}>
                                                                                            <ErrorMessage name={`processAuditReportDetails[${index}].comments`} />
                                                                                            </div>
                                                                                        
                                                                                        </div>

                                                                                        <div className="fieldarray mt-3">

                                                                                            <FieldArray name={`processAuditReportDetails[${index}].clauseWiseObservation`}>

                                                                                                {fieldArrayProps => {
                                                                                                    const { push, remove, form } = fieldArrayProps
                                                                                                    const { values } = form
                                                                                                    const { clauseWiseObservation } = values
                                                                                                    return (
                                                                                                        <div>
                                                                                                            {processAuditReportDetails[index].clauseWiseObservation.map((clauseDetail, i) => (
                                                                                                                <div key={index}>
                                                                                                                    <div className="form2RowDiv">
                                                                                                                        <div className="formSingleElement">
                                                                                                                            {<FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`} label='Clause' options={processAuditReportDetails[index].clausesList}
                                                                                                                                onChange={(e) => {

                                                                                                                                    var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                                                                                    if (fillteredprocess) {
                                                                                                                                        swal({
                                                                                                                                            title: "Clause is Already selected",
                                                                                                                                            icon: "warning",
                                                                                                                                            dangerMode: true,
                                                                                                                                        })
                                                                                                                                    } else {
                                                                                                                                        var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                                                                                        if (fillteredprocess) {
                                                                                                                                            swal({
                                                                                                                                                title: "Clause is Already selected",
                                                                                                                                                icon: "warning",
                                                                                                                                                dangerMode: true,
                                                                                                                                            })
                                                                                                                                        } else {

                                                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`, e.value)
                                                                                                                                         //   console.log("value of caluse",`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`)
                                                                                                                                            // formik.setFieldValue(`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNolabel`, e.label)

                                                                                                                                            //formik.setFieldValue(`clauseWiseObservation[${index}].reference`, e.listClauses)

                                                                                                                                        }
                                                                                                                                    }

                                                                                                                                }

                                                                                                                                }
                                                                                                                            />}

                                                                                                                        </div>
                                                                                                                        <div className="formSingleElement">
                                                                                                                            <label className="formSingleElementLabel">Observation</label>
                                                                                                                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                                                                                            <div style={{ color: "red" }}>
                                                                                                                                <ErrorMessage name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                                                                                            </div>
                                                                                                                       </div>
                                                                                                                    </div>

                                                                                                                    {i > 0 && (
                                                                                                                        <div className="col-sm-4">
                                                                                                                            <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(i)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                                                        </div>
                                                                                                                    )}

                                                                                                                    <hr />

                                                                                                                </div>

                                                                                                            ))}


                                                                                                            <div className="row mt-3">
                                                                                                                <div className="col-lg-11"></div>
                                                                                                                <div className="col-lg-1 mb-3" >
                                                                                                                    <button type='button' className="btn btn-primary" onClick={() => push({
                                                                                                                        clauseNo: "",
                                                                                                                        Observation: "",

                                                                                                                    })}> + </button>
                                                                                                                </div>
                                                                                                            </div>


                                                                                                        </div>

                                                                                                    )
                                                                                                }}
                                                                                            </FieldArray>



                                                                                        </div>
                                                                                        {index > 0 && (
                                                                                            <div className="col-sm-4">
                                                                                                <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                            </div>
                                                                                        )}
                                                                                        <hr />
                                                                                    </div>

                                                                                ))}
                                                                                <div className="row mt-3">
                                                                                    <div className="col-lg-11"></div>
                                                                                    <div className="col-lg-1 mb-3" >
                                                                                        <button type='button' className="btn btn-primary" onClick={() => push({
                                                                                            nameofprocess: "",
                                                                                            nameofprocessid:"",
                                                                                            processowner: "",
                                                                                            details: "",
                                                                                            reference: "",
                                                                                            comments: "",
                                                                                            clauseWiseObservation: [{ clauseNo: "", Observation: "" }]

                                                                                        })}>Add</button>
                                                                                    </div>
                                                                                </div>


                                                                            </div>

                                                                        )
                                                                    }}
                                                                </FieldArray>
                                                                <hr />
                                                            </div>

                                                            <div className="row mt-4" style={{ marginLeft: "1%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-2 mt-5">Auditor Team Observation & Nonconformity </label>
                                                                <div className="col-sm-9 mt-4">
                                                                    <FormikControl control='ckEditor' name='auditorteamObservation' className="form-control" data={initialValues.auditorteamObservation} />
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4" style={{ marginLeft: "1%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-2 mt-5">Nonconformity if any</label>
                                                                <div className="col-sm-9 mt-4">
                                                                    <FormikControl control='ckEditor' name='noncom' className="form-control" data={initialValues.noncom} />
                                                                </div>
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='select' type="text" name='stageofaudit' options={stageaudit} label='A. Stage of audit'
                                                                    onChange={e => {
                                                                        formik.setFieldValue(`stageofaudit`, e.currentTarget.value)
                                                                        e.currentTarget.value === 'other' ? setotherOption(true)

                                                                            :
                                                                            setotherOption(false)
                                                                        formik.setFieldValue(`otherstageofaudit`, '')

                                                                    }} />
                                                                {
                                                                    otherOptions ?
                                                                        <FormikControl control='input' type="text" name='otherstageofaudit' label='Other Satge of Audit' />
                                                                        : ""
                                                                }
                                                            </div>
                                                           
                                                           
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='date' dateFormat="dd-MM-yyyy"name='signofDate' className="form-control" label='Report submission Date' />

                                                            </div>
                                                            


                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='teamleaderName' label=' IQCPL Report Submission Name of Auditor' />
                                                            </div>

                                                            
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='contactPersonName' label='Client Name for Acceptance of Report' />
                                                                <FormikControl control='input' type="text" name='position' label='Designation' />

                                                            </div>

                                                        </div>

                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>

                </Form>
                }
            </Formik>
        </div>
    )
}

export default ImsNewFormsStage2